import * as React from 'react';
import {
    Button, ButtonType, Dropdown, IDropdownOption
} from 'office-ui-fabric-react';
import DecisionConfigContainer from '../../containers/decision-config';
import Collapsible from 'react-collapsible';
import store from '../../store/store';


interface IProps {
    componentId: string;
    previousOutputBlocks: any;
    componentDialogToggle?: () => void;
    toggleDecisionConfigDialog: (componentId: string, previousOutputBlocks: any) => void;
    setNextComponentId: (elementId: string, componentId: string, nextComponentId: string, elementType: string) => any;
    conditions: any[];
    component: any;
}
let childElement: JSX.Element;


export class Decision extends React.Component<IProps, any> {

    // componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<any>, snapshot?: any): void {
    //     // let { componentId, toggleDecisionConfigDialog, previousOutputBlocks } = this.props;
    //     // toggleDecisionConfigDialog(componentId, previousOutputBlocks);
    // }

    // componentDidMount(): void {
    //     let { componentId, toggleDecisionConfigDialog, previousOutputBlocks } = this.props;
    //     toggleDecisionConfigDialog(componentId, previousOutputBlocks);
    //     this.getChildren();
    // }
    // getChildren() {
    //     childElement = <DecisionConfigContainer />;
    // }

    // render() {
    //     let { componentId, toggleDecisionConfigDialog, previousOutputBlocks, setNextComponentId, conditions, component } = this.props;
    //     // let { decision, branchEditIndex, editedBranch } = this.props.state;
    //     // let { operators, operatorTypes } = this.props.cache;
    //     let outputOptions: IDropdownOption[] = [];
    //     let shouldRender = store.getState().modalState.decisionConfig.componentId ? componentId === store.getState().modalState.decisionConfig.componentId : false;
    //     return (
    //         <div>
    //             <Collapsible
    //                 trigger={<Button buttonType={ButtonType.primary}
    //                     label='Configure this decision'
    //                     title='Configure this decision'
    //                     icon='Settings'
    //                     onClick={(e) => {
    //                         toggleDecisionConfigDialog(componentId, previousOutputBlocks), this.getChildren()
    //                     }}
    //                 />
    //                 } open={shouldRender} >
    //                 {childElement}
    //             </Collapsible>

    //         </div >

    //     );
    // }

    getChildren() {
        let { componentDialogToggle } = this.props;
        childElement = <DecisionConfigContainer componentDialogToggle={componentDialogToggle} />;
    }

    componentDidMount(): void {
        this.getChildren();
    }



    render() {
        let { componentId, toggleDecisionConfigDialog, previousOutputBlocks, setNextComponentId, conditions, component } = this.props;

        return (
            <div>
                {childElement}
                {/* <Collapsible onOpen={() => { toggleDecisionConfigDialog(componentId, previousOutputBlocks), this.getChildren() }} trigger={
                    <Button buttonType={ButtonType.primary}
                        label='Configure this decision'
                        title='Configure this decision'
                        icon='Settings'
                    // onClick={(e) => toggleDecisionConfigDialog(componentId, previousOutputBlocks)} 
                    />
                }>This is decision</Collapsible> */}
            </div >

        );
    }



}


// WEBPACK FOOTER //
// ./source/ts/components/components/decision.tsx